export default __webpack_public_path__ + "static/media/icon-stop.8efa1a16.svg";